import React from "react";
import PropTypes from "prop-types";
import SliderControl from "./SliderControl";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

const Container = styled.div`
  position: relative;
  overflow: visible;
`;

const Track = styled.div.attrs({ "data-testid": "slider-track" })`
  display: block;
  width: 100%;
  background-color: ${cloud.getShade(4)};
  position: absolute;
`;

const Thumb = styled.div.attrs({ "data-testid": "slider-thumb" })`
  display: block;
  position: absolute;
  transition: transform 0.2s;
  cursor: pointer;
  ${props => props.isHighlighted && "transform: scale(1.2);"}
`;

export default class Slider extends React.Component {
  boundGetWidth = this.getWidth.bind(this);
  boundGetContainerOffset = this.getContainerOffset.bind(this);
  boundRenderSlider = this.renderSlider.bind(this);

  getWidth() {
    const el = this.getContainerElement();
    return el ? el.offsetWidth : 0;
  }

  getContainerOffset() {
    const el = this.getContainerElement();
    if (el) {
      return el.getBoundingClientRect().left;
    }
    return 0;
  }

  getContainerElement() {
    return this.container;
  }

  renderSlider({ onThumbDown, thumbStyle, containerProps }) {
    return (
      <Container
        ref={el => (this.container = el)}
        {...containerProps}
        style={{
          padding: `${this.props.trackPaddingVert}px ${
            this.props.trackPaddingHoriz
          }px`
        }}
      >
        <Track
          style={{
            height: this.props.trackHeight,
            width: `calc(100% - ${this.props.trackPaddingHoriz * 2}px)`,
            top: this.props.trackPaddingVert - this.props.trackHeight / 2,

            // transparent border needed for the track to be visible in windows
            // high contrast mode
            border: "1px solid transparent",
          }}
        />
        <Thumb
          style={{
            ...thumbStyle,
            height: this.props.thumbHeight,
            width: this.props.thumbWidth,
            borderRadius: this.props.thumbHeight / 2,
            top: this.props.trackPaddingVert - this.props.thumbHeight / 2,
            backgroundColor: this.props.thumbColor,

            // transparent border needed for the thumb to be visible in windows
            // high contrast mode
            border: "1px solid transparent",
          }}
          isHighlighted={this.props.isHighlighted}
          onMouseDown={onThumbDown}
          onTouchStart={onThumbDown}
        />
      </Container>
    );
  }

  render() {
    return (
      <SliderControl
        trackPadding={this.props.trackPaddingHoriz}
        thumbWidth={this.props.thumbWidth}
        getWidth={this.boundGetWidth}
        getContainerOffset={this.boundGetContainerOffset}
        onChange={this.props.onChange}
        percent={this.props.percentage}
        render={this.boundRenderSlider}
        label={this.props.label}
      />
    );
  }
}

Slider.propTypes = {
  label: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
};
